var _defs, _g, _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0;}.cls-2{opacity:0.13;}.cls-3{fill:red;}.cls-4{opacity:0.1;}.cls-5{fill:#ff6700;}.cls-6{opacity:0.09;}.cls-7{opacity:0.03;}.cls-8{fill:currentColor;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_\u6302\u53F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.99,
    y: 4,
    width: 56,
    height: 56
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 31.98,
    cy: 32,
    r: 28
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.99,
    y: 8,
    width: 56,
    height: 48
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.99,
    y: 4,
    width: 48,
    height: 56
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 19.98,
    y: 8.02,
    width: 4,
    height: 7.97,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 29.98,
    y: 22,
    width: 4,
    height: 23.99,
    rx: 2,
    transform: "translate(-2.02 65.98) rotate(-90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 29.98,
    y: 22,
    width: 4,
    height: 23.99,
    rx: 2,
    transform: "translate(63.96 68) rotate(-180)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 39.98,
    y: 8.02,
    width: 4,
    height: 7.97,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M56,16V52H8V16H56m2-4H6a2,2,0,0,0-2,2V54a2,2,0,0,0,2,2H58a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.38bb81fd.svg";
export { ForwardRef as ReactComponent };